import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios';
import '@fortawesome/fontawesome-free/css/all.css'
import './assets/css/app.sass'
import VueTheMask from 'vue-the-mask'
import { mask } from 'vue-the-mask'
import vSelect from 'vue-select'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap/dist/js/bootstrap.js'
import 'vue-select/dist/vue-select.css';
import VueConfirmDialog from 'vue-confirm-dialog'
import money from 'v-money'
import 'vue2-datepicker/index.css'
import 'vue2-datepicker/locale/pt-br'
import VueSweetalert2 from 'vue-sweetalert2'
import 'sweetalert2/dist/sweetalert2.min.css'
import $ from 'jquery'
import VueObserveVisibility from 'vue-observe-visibility'
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";

Vue.use(money, {
    decimal: ',',
    thousands: '.',
    prefix: 'R$ ',
    suffix: '',
    precision: 2,
    masked: false
})

window.jQuery = $
window.$ = $

Vue.use(Toast)
Vue.use(VueTheMask)
Vue.use(VueConfirmDialog)
Vue.use(VueSweetalert2)
Vue.use(VueObserveVisibility)

Vue.directive('mask', mask)

Vue.component('v-select', vSelect)
Vue.component('vue-confirm-dialog', VueConfirmDialog.default)

Vue.config.productionTip = false

axios.interceptors.request.use((config) => {
    config.url = process.env.VUE_APP_URL + config.url
    config.timeout = 300000
    if (config.params === undefined) {
        config.params = {}
    }
    config.params.api_token = store.getters['auth/token']
    return config;
});

axios.interceptors.response.use((response) => {
    return response
}, (error) => {
    if (error.response.status === 401) {
        store.state.auth.user = {}
        router.push({
            name: 'login'
        });

        return Promise.reject(error)
    }

    return Promise.reject(error)
})

new Vue({
    router,
    store,
    render: h => h(App),
}).$mount('#app')
